import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-4xl mx-auto px-4 py-10 space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">Política de Privacidade</h1>
          <p className="text-muted-foreground">
            Esta política descreve como coletamos, usamos e protegemos suas informações pessoais.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>1. Coleta de Dados</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm leading-relaxed">
            <p>
              Coletamos informações que você nos fornece diretamente, como nome, e-mail, 
              dados de pagamento e informações financeiras inseridas na plataforma.
            </p>
            <p>
              Também coletamos automaticamente dados de uso, como endereço IP, tipo de navegador 
              e páginas visitadas, para melhorar sua experiência.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>2. Uso das Informações</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>• Fornecer e manter nossos serviços de planejamento financeiro.</p>
            <p>• Processar pagamentos e gerenciar sua assinatura.</p>
            <p>• Enviar comunicações sobre sua conta e atualizações do serviço.</p>
            <p>• Melhorar e personalizar sua experiência na plataforma.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>3. Proteção de Dados</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>
              Implementamos medidas de segurança técnicas e organizacionais para proteger 
              suas informações contra acesso não autorizado, alteração ou destruição.
            </p>
            <p>
              Seus dados financeiros são criptografados e armazenados em servidores seguros.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>4. Compartilhamento de Dados</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>
              Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros 
              para fins de marketing. Podemos compartilhar dados apenas:
            </p>
            <p>• Com provedores de serviço que nos auxiliam nas operações.</p>
            <p>• Quando exigido por lei ou processo legal.</p>
            <p>• Para proteger nossos direitos e segurança.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>5. Seus Direitos</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>
              Conforme a Lei Geral de Proteção de Dados (LGPD), você tem direito a:
            </p>
            <p>• Acessar seus dados pessoais.</p>
            <p>• Corrigir dados incompletos ou imprecisos.</p>
            <p>• Solicitar a exclusão de seus dados.</p>
            <p>• Revogar seu consentimento a qualquer momento.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>6. Contato</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>
              Para questões sobre esta política ou sobre seus dados pessoais, 
              entre em contato conosco pelo menu "Suporte" dentro do aplicativo 
              ou pelo e-mail: contato@librattum.com.br
            </p>
          </CardContent>
        </Card>

        <Separator />
        <p className="text-xs text-muted-foreground">
          Última atualização: 15/12/2025 — Librattum Inteligência Financeira
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;









